import { observer } from 'mobx-react';
import React from 'react';

import './styles.scss';

type PropsType = {
    progress?: number | null;
    size?: number;
};

export const PPDWidgetCompareChart = observer(({ progress, size = 152 }: PropsType) => {
    const isValidProgress = progress !== undefined && progress !== null && !isNaN(progress);

    if (!isValidProgress) {
        return (
            <div
                className="ppd-widget-compare-chart"
                style={{ width: size, height: size }}
            >
                <div className="ppd-widget-compare-chart__circle"></div>
                <div className="ppd-widget-compare-chart__value">—</div>
            </div>
        );
    }

    const isTrendUp = progress > 0;
    const chartColor =
        progress > 0
            ? '#22C55E'
            : progress < 0
                ? '#F43F5E'
                : '#FB923C';
    const renderChartArrow = () => (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: !isTrendUp ? 'rotate(180deg)' : '' }}
            className='ppd-widget-compare-chart__arrow'
        >
            <path d="M1 8L8 1M8 1L15 8M8 1V15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    return (
        <div className='ppd-widget-compare-chart' style={{ width: size, height: size }}>
            <div className="ppd-widget-compare-chart__circle" style={{ backgroundColor: chartColor }}></div>
            <div className='ppd-widget-compare-chart__value'>
                {isTrendUp && '+'}
                { progress }
                <span className='ppd-widget-compare-chart__percent'>
                    %
                </span>
                {renderChartArrow()}
            </div>
        </div>
    );
});
